import * as React from 'react'

import { Box, EnhancedDimension, Skeleton } from '@factorialco/deprecated-design-system'
import { sample } from 'lodash'

export const FeedbackSkeletonDisplay = () => {
  // eslint-disable-next-line no-type-assertion/no-type-assertion
  const firstLineWidth = sample(['s360', 's200', 's240', 's300']) as EnhancedDimension
  // eslint-disable-next-line no-type-assertion/no-type-assertion
  const secondLineWidth = sample(['s200', 's120', 's140']) as EnhancedDimension

  return (
    <Box
      padding="s24"
      border={{ all: { width: 's1', style: 'solid', color: 'grey300' } }}
      borderRadius={{ all: 'abs008' }}
    >
      <Box>
        <Box gap="s24" width="full">
          <Box flexDirection="row" gap="s8" alignItems="center">
            <Skeleton width="s40" height="s40" />
            <Box gap="s8" flexDirection="row">
              <Skeleton width="s140" height="s12" />
            </Box>
            <Skeleton width="s24" height="s24" />
          </Box>
          <Box gap="s12">
            <Skeleton width={firstLineWidth} height="s12" />
            <Skeleton width={secondLineWidth} height="s12" />
          </Box>
          <Skeleton width="s140" height="s8" />
        </Box>
      </Box>
    </Box>
  )
}
